package one.healthium.data.user.dto

import dev.gitlive.firebase.firestore.Timestamp
import dev.gitlive.firebase.firestore.TimestampSerializer
import dev.gitlive.firebase.firestore.fromMilliseconds
import kotlinx.serialization.KSerializer
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlinx.serialization.descriptors.SerialDescriptor
import kotlinx.serialization.encoding.Decoder
import kotlinx.serialization.encoding.Encoder
import one.healthium.common.serializers.SafeFloatSerializer

@Serializable
internal data class WaterLogDto(
    @Serializable(CustomTimestampSerializer::class) @SerialName(FIELD_DATE) val date: Timestamp,
    @SerialName("water") @Serializable(with = SafeFloatSerializer::class) val water: Float,
) {
    companion object {
        const val FIELD_DATE = "date"
    }
}

internal object CustomTimestampSerializer : KSerializer<Timestamp> {
    override val descriptor: SerialDescriptor
        get() = TimestampSerializer.descriptor

    override fun deserialize(decoder: Decoder): Timestamp {
        return try {
            TimestampSerializer.deserialize(decoder)
        } catch (e: Exception) {
            val doubleValue = decoder.decodeDouble()
            // native iOS app store date as interval between the date object and 00:00:00 UTC on 1 January 2001
            // so we have to convert it
            Timestamp.fromMilliseconds(978307200000 + (doubleValue * 1000))
        }
    }

    override fun serialize(encoder: Encoder, value: Timestamp) {
        TimestampSerializer.serialize(encoder, value)
    }
}
